import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { blue, ChronosphereColorPalette } from '../colors';
import { buildPaletteForMode, type PaletteTokenMetadata, type Token } from '../panw-palette/token-metadata';

const infoColorTokens = [
  { propertyPath: 'main', tokenName: '--semantic-data-informative-informative' },
  { propertyPath: 'highContrast', tokenName: '--data-informative-informative-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--data-informative-informative-low-contrast' },
] satisfies Token[];

export const infoColorMetadata: PaletteTokenMetadata = {
  componentName: 'status-info',
  tokens: infoColorTokens,
};

export const infoColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(infoColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: blue[500],
        highContrast: blue[700],
        lowContrast: blue[100],
      }
    : {
        main: blue[400],
        highContrast: blue[100],
        lowContrast: blue[800],
      };
};
